import { inject, Injectable } from '@angular/core';
import { IPopup, PopupComponent } from '../features/issuing-process/components/popup/popup.component';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Injectable({ providedIn: 'root' })
export class PopupService {

  private _bottomSheet = inject(MatBottomSheet);

  constructor() { }

  openPopup(data: IPopup, panelClass: string = '') : MatBottomSheetRef<PopupComponent> {
    return this._bottomSheet.open(PopupComponent, { data, panelClass });
  }
}
